// eslint-disable-next-line import/no-anonymous-default-export
export default {
  "chatServer": "wss://chat.elbetdev.com:8765",
  "gameServers": ["https://server.fastballs.elbetdev.com:9334"]
}
